import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const ContainerProgressBar = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
	width: 100%;
`;

export const ContainerBar = styled.div`
	position: relative;
	display: grid;
	grid-template-columns: 80px 1fr;

	.textLabel {
		font-family: ${tokens.font_family_primary};
		font-weight: 500;
		font-size: 14px;
		color: ${tokens.color_gray_dark};
	}

	.percentLabel {
		position: absolute;
		top: -12px;
		right: 22%;
		font-size: 12px;
		color: ${tokens.color_gray_dark};
		font-weight: 600;

		@media (max-width: 1250px) {
			right: 20%;
		}
	}

	div {
		display: grid;
		grid-template-columns: 1fr 0.35fr;
	}
`;
